import { IApplicationState } from '../../../types/redux';

/**
 * Возвращает тип текущей страницы
 */
export const selectListingAppendType = ({ settings: { listingAppendType } }: IApplicationState) => listingAppendType;
